import { render, staticRenderFns } from "./deploy.vue?vue&type=template&id=5aaff65c&scoped=true"
import script from "./deploy.vue?vue&type=script&lang=js"
export * from "./deploy.vue?vue&type=script&lang=js"
import style0 from "./deploy.vue?vue&type=style&index=0&id=5aaff65c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaff65c",
  null
  
)

export default component.exports